/**
 * Yarbo product catalog — primary data source.
 *
 * Intake mode: populated incrementally from PRODUCT DATA CHUNKs.
 * Do NOT wire to storefront UI until FINALIZE PRODUCT DATA AND BUILD
 * ECOMMERCE APP is received.
 */

export type YarboProduct = {
  id: string
  slug: string
  sku: string
  name: string
  price: number
  priceDisplay?: string
  compareAtPrice?: number | null
  imageUrl?: string
  websiteForgeImagePath?: string
  image?: string
  images?: string[]
  descriptionHtml?: string
  descriptionText?: string
  shortDescription?: string
  description?: string
  primaryGroup?: string
  publicCategories?: string[]
  taskCategories?: string[]
  categories?: string[]
  status?: string
  stockLabel?: string
  weightLbs?: number | string | null
  weightNote?: string | null
  weightSource?: string | null
  options?: string
  requiresCore?: boolean
  isAccessory?: boolean
  isBundle?: boolean
  isCompleteSystem?: boolean
  isModule?: boolean
  eligibleForYarboCare?: boolean
  yarboCareEligible?: boolean
  brochureUrl?: string | null
  brochureLinkText?: string | null
  seoTitle?: string
  seoMetaDescription?: string
  seoMetaKeywords?: string
  sourceUrl?: string
}

export const yarboProducts: YarboProduct[] = [
  {
    id: '38-4ah-battery',
    slug: '38-4ah-battery',
    sku: 'YARBO-38-4AH-BATTERY',
    name: '38.4Ah Battery (Y Series)',
    price: 1199.0,
    priceDisplay: '$1,199.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Power & Charging',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Power & Charging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Battery.png?v=1777095773&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Battery.png',
    descriptionHtml:
      '<p>Official 38.4Ah Battery (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official 38.4Ah Battery (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo 38.4Ah Battery | Y Series Replacement Battery',
    seoMetaDescription:
      'Shop 38.4Ah Battery (Y Series) for Yarbo Y Series systems. Buy replacement power and charging parts online.',
    seoMetaKeywords:
      'Yarbo, 38.4Ah Battery, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'anti-slip-studs-for-rubber-track',
    slug: 'anti-slip-studs-for-rubber-track',
    sku: 'YARBO-ANTI-SLIP-STUDS-FOR-RUBBER-TRACK',
    name: 'Anti-Slip Studs for Rubber Track (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Anti-SlipStudsforRubberTrack_100Pcs.png?v=1777096045&width=533',
    websiteForgeImagePath:
      'uploaded/images/Anti-SlipStudsforRubberTrack_100Pcs.png',
    descriptionHtml:
      '<p>Official Anti-Slip Studs for Rubber Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Anti-Slip Studs for Rubber Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Anti-Slip Studs | Rubber Track Accessory',
    seoMetaDescription:
      'Shop Anti-Slip Studs for Rubber Track (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Anti-Slip Studs for Rubber Track, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'back-brace-mount',
    slug: 'back-brace-mount',
    sku: 'YARBO-BACK-BRACE-MOUNT',
    name: 'Back Brace Mount (Y Series)',
    price: 149.0,
    priceDisplay: '$149.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Trimming & Edging'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop by Task/Trimming & Edging',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Tow_Hitch_Back_Brace_Mount_1.png?v=1777548568&width=533',
    websiteForgeImagePath: 'uploaded/images/Tow_Hitch_Back_Brace_Mount_1.png',
    descriptionHtml:
      '<p>Official Back Brace Mount (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Back Brace Mount (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Back Brace Mount | Y Series Accessory',
    seoMetaDescription:
      'Shop Back Brace Mount (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Back Brace Mount, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'battery-power-cord',
    slug: 'battery-power-cord',
    sku: 'YARBO-BATTERY-POWER-CORD',
    name: 'Battery Power Cord (Y Series)',
    price: 59.0,
    priceDisplay: '$59.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Power & Charging',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Power & Charging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Battery_Power_Cord_e96bccdd-a511-47f1-bde7-0b27251fdf27.png?v=1777110057&width=533',
    websiteForgeImagePath:
      'uploaded/images/Battery_Power_Cord_e96bccdd-a511-47f1-bde7-0b27251fdf27.png',
    descriptionHtml:
      '<p>Official Battery Power Cord (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Battery Power Cord (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Battery Power Cord | Y Series Part',
    seoMetaDescription:
      'Shop Battery Power Cord (Y Series) for Yarbo Y Series systems. Buy replacement power and charging parts online.',
    seoMetaKeywords:
      'Yarbo, Battery Power Cord, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-blower',
    slug: 'yarbo-blower',
    sku: 'YARBO-BLOWER',
    name: 'Yarbo Blower',
    price: 4799.0,
    priceDisplay: '$4,799.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Complete System',
    publicCategories: ['Complete Systems', 'Leaf Blowers'],
    taskCategories: ['Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Leaf Blowers',
      '/Shop by Task/Leaf Cleanup',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Blower.png?v=1777093280&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Blower.png',
    descriptionHtml:
      '<p>A complete Yarbo robotic blower system for leaves, clippings, and outdoor debris cleanup.</p>\n<ul>\n<li>21 N blowing force</li>\n<li>70-minute runtime per charge</li>\n<li>Handles supported slopes up to 35 degrees / 70 percent</li>\n</ul>\n<p><strong>Includes:</strong> Yarbo Core, Blower Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation &amp; Tool Kit and Tow Hitch.</p>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A complete Yarbo robotic blower system for leaves, clippings, and outdoor debris cleanup. 21 N blowing force; 70-minute runtime per charge; Handles supported slopes up to 35 degrees / 70 percent Includes: Yarbo Core, Blower Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation & Tool Kit and Tow Hitch. Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: false,
    isCompleteSystem: true,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Leaf Blower | Robotic Yard Cleanup',
    seoMetaDescription:
      'Shop Yarbo Blower for robotic leaf cleanup, driveway debris, clippings, and outdoor cleanup routes with autonomous yard care.',
    seoMetaKeywords:
      'Yarbo, Yarbo Blower, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-leaf-blower',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'blower-module',
    slug: 'blower-module',
    sku: 'YARBO-BLOWER-MODULE',
    name: 'Blower Module (Y Series)',
    price: 1099.0,
    priceDisplay: '$1,099.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories'],
    taskCategories: ['Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Blower_Module.png?v=1777093279&width=533',
    websiteForgeImagePath: 'uploaded/images/Blower_Module.png',
    descriptionHtml:
      '<p>A module-only Yarbo Blower attachment for leaves, clippings, and outdoor debris cleanup.</p>\n<ul>\n<li>Module-only product</li>\n<li>Leaf and debris cleanup</li>\n<li>Requires a compatible Yarbo Core</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A module-only Yarbo Blower attachment for leaves, clippings, and outdoor debris cleanup. Module-only product; Leaf and debris cleanup; Requires a compatible Yarbo Core Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Blower Module | Robotic Leaf Blower Module',
    seoMetaDescription:
      'Shop Blower Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Blower Module, Yarbo leaf blower, robotic leaf blower, yard cleanup robot, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/blower-module',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'blower-module-cover',
    slug: 'blower-module-cover',
    sku: 'YARBO-BLOWER-MODULE-COVER',
    name: 'Blower Module Cover (Y Series)',
    price: 30.0,
    priceDisplay: '$30.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Blower_Module_Cover.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Blower_Module_Cover.png',
    descriptionHtml:
      '<p>Official Blower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Blower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Blower Module Cover | Y Series Accessory',
    seoMetaDescription:
      'Shop Blower Module Cover (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Blower Module Cover, Yarbo leaf blower, robotic leaf blower, yard cleanup robot, Yarbo module, Yarbo Y Series module, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'bluetooth-antenna-for-data-center',
    slug: 'bluetooth-antenna-for-data-center',
    sku: 'YARBO-BLUETOOTH-ANTENNA-FOR-DATA-CENTER',
    name: 'Bluetooth Antenna for Data Center',
    price: 22.0,
    priceDisplay: '$22.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Bluetooth_Antenna_for_Data_Center.png?v=1777095772&width=533',
    websiteForgeImagePath:
      'uploaded/images/Bluetooth_Antenna_for_Data_Center.png',
    descriptionHtml:
      '<p>Official Bluetooth Antenna for Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Bluetooth Antenna for Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Bluetooth Antenna for Data Center',
    seoMetaDescription:
      'Shop Bluetooth Antenna for Data Center for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Bluetooth Antenna for Data Center, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-cap',
    slug: 'yarbo-cap',
    sku: 'YARBO-CAP',
    name: 'Yarbo Cap',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Apparel'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Apparel',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Cap.png?v=1777095775&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Cap.png',
    descriptionHtml:
      '<p>Official Yarbo Cap for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Yarbo Cap for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Cap | Yarbo Apparel',
    seoMetaDescription:
      'Shop Yarbo Cap, Yarbo apparel and branded gear available online.',
    seoMetaKeywords: 'Yarbo, Yarbo Cap',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-core',
    slug: 'yarbo-core',
    sku: 'YARBO-CORE',
    name: 'Yarbo Core',
    price: 3999.0,
    priceDisplay: '$3,999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Complete System',
    publicCategories: ['Complete Systems', 'Modules & Accessories', 'Core'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Core',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Core.png?v=1777093280&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Core.png',
    descriptionHtml:
      '<p>The Yarbo Core is the central tracked robotic platform used with compatible Yarbo modules and accessories.</p>\n<ul>\n<li>Base robotic platform</li>\n<li>Compatible with supported Y Series modules</li>\n<li>For customers building or expanding a Yarbo setup</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'The Yarbo Core is the central tracked robotic platform used with compatible Yarbo modules and accessories. Base robotic platform; Compatible with supported Y Series modules; For customers building or expanding a Yarbo setup Product Brochure',
    weightLbs: 134.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: false,
    isCompleteSystem: true,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Core | Modular Yard Robot Platform',
    seoMetaDescription:
      'Shop Yarbo Core for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Yarbo Core',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote: 'Official Yarbo Wiki core full unit weight: 61 kg / 134 lbs.',
  },
  {
    id: 'core-cover',
    slug: 'core-cover',
    sku: 'YARBO-CORE-COVER',
    name: 'Core Cover (Y Series)',
    price: 39.0,
    priceDisplay: '$39.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Core'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Core',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Core_Cover.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Core_Cover.png',
    descriptionHtml:
      '<p>Official Core Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Core Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Core Cover | Y Series Cover',
    seoMetaDescription:
      'Shop Core Cover (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Core Cover, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'cutting-blades-and-bolts-40-pcs',
    slug: 'cutting-blades-and-bolts-40-pcs',
    sku: 'YARBO-CUTTING-BLADES-BOLTS-40-PCS',
    name: 'Cutting Blades & Bolts - 40 Pcs (Y Series)',
    price: 39.0,
    priceDisplay: '$39.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Cutting_Blades_Bolts_40_Pcs.png?v=1777095774&width=533',
    websiteForgeImagePath: 'uploaded/images/Cutting_Blades_Bolts_40_Pcs.png',
    descriptionHtml:
      '<p>Official Cutting Blades &amp; Bolts - 40 Pcs (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Cutting Blades & Bolts - 40 Pcs (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Cutting Blades & Bolts 40 Pcs | Mower Parts',
    seoMetaDescription:
      'Shop Cutting Blades & Bolts - 40 Pcs (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Cutting Blades & Bolts - 40 Pcs, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'cutting-disc-and-bolts',
    slug: 'cutting-disc-and-bolts',
    sku: 'YARBO-CUTTING-DISC-BOLTS',
    name: 'Cutting Disc & Bolts (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Cutting_Disc_Bolts.png?v=1777095774&width=533',
    websiteForgeImagePath: 'uploaded/images/Cutting_Disc_Bolts.png',
    descriptionHtml:
      '<p>Official Cutting Disc &amp; Bolts (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Cutting Disc & Bolts (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Cutting Disc & Bolts | Mower Parts',
    seoMetaDescription:
      'Shop Cutting Disc & Bolts (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Cutting Disc & Bolts, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'cutting-disc-and-bolts-for-lawn-mower-pro-module',
    slug: 'cutting-disc-and-bolts-for-lawn-mower-pro-module',
    sku: 'YARBO-CUTTING-DISC-BOLTS-FOR-LAWN-MOWER-PRO-MODULE',
    name: 'Cutting Disc & Bolts - for Lawn Mower Pro Module (Y Series)',
    price: 49.0,
    priceDisplay: '$49.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Cutting_Disc_Bolts_for_Lawn_Mower_Pro_Module.png?v=1777095773&width=533',
    websiteForgeImagePath:
      'uploaded/images/Cutting_Disc_Bolts_for_Lawn_Mower_Pro_Module.png',
    descriptionHtml:
      '<p>Official Cutting Disc &amp; Bolts - for Lawn Mower Pro Module (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Cutting Disc & Bolts - for Lawn Mower Pro Module (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Cutting Disc & Bolts | Mower Pro Parts',
    seoMetaDescription:
      'Shop Cutting Disc & Bolts - for Lawn Mower Pro Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Cutting Disc & Bolts - for Lawn Mower Pro Module, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower, Yarbo module, Yarbo Y Series module, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'data-center',
    slug: 'data-center',
    sku: 'YARBO-DATA-CENTER',
    name: 'Data Center',
    price: 219.0,
    priceDisplay: '$219.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Data_Center.png?v=1777095772&width=533',
    websiteForgeImagePath: 'uploaded/images/Data_Center.png',
    descriptionHtml:
      '<p>Official Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Data Center | RTK Navigation Accessory',
    seoMetaDescription:
      'Shop Data Center for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Data Center',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'docking-station',
    slug: 'docking-station',
    sku: 'YARBO-DOCKING-STATION',
    name: 'Docking Station (Y Series)',
    price: 899.0,
    priceDisplay: '$899.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Power & Charging',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Power & Charging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Docking_Station.png?v=1777095775&width=533',
    websiteForgeImagePath: 'uploaded/images/Docking_Station.png',
    descriptionHtml:
      '<p>Official Docking Station (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Docking Station (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Docking Station | Y Series Charging Dock',
    seoMetaDescription:
      'Shop Docking Station (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Docking Station',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-down-jacket',
    slug: 'yarbo-down-jacket',
    sku: 'YARBO-DOWN-JACKET',
    name: 'Yarbo Down Jacket',
    price: 479.0,
    priceDisplay: '$479.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Apparel'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Apparel',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Down_Jacket.png?v=1777095772&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Down_Jacket.png',
    descriptionHtml:
      '<p>Official Yarbo Down Jacket for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Yarbo Down Jacket for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Down Jacket | Yarbo Apparel',
    seoMetaDescription:
      'Shop Yarbo Down Jacket, Yarbo apparel and branded gear available online.',
    seoMetaKeywords: 'Yarbo, Yarbo Down Jacket',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'halow-antenna-for-data-center',
    slug: 'halow-antenna-for-data-center',
    sku: 'YARBO-HALOW-ANTENNA-FOR-DATA-CENTER',
    name: 'HaLow Antenna for Data Center',
    price: 22.0,
    priceDisplay: '$22.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/HaLow_Antenna_for_Data_Center.png?v=1777095772&width=533',
    websiteForgeImagePath: 'uploaded/images/HaLow_Antenna_for_Data_Center.png',
    descriptionHtml:
      '<p>Official HaLow Antenna for Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official HaLow Antenna for Data Center for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo HaLow Antenna for Data Center',
    seoMetaDescription:
      'Shop HaLow Antenna for Data Center for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, HaLow Antenna for Data Center, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'halow-antenna-for-rover',
    slug: 'halow-antenna-for-rover',
    sku: 'YARBO-HALOW-ANTENNA-FOR-ROVER',
    name: 'HaLow Antenna for Rover (Y Series)',
    price: 22.0,
    priceDisplay: '$22.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/HaLow_Antenna_for_Rover.png?v=1777095772&width=533',
    websiteForgeImagePath: 'uploaded/images/HaLow_Antenna_for_Rover.png',
    descriptionHtml:
      '<p>Official HaLow Antenna for Rover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official HaLow Antenna for Rover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo HaLow Antenna for Rover | Y Series Antenna',
    seoMetaDescription:
      'Shop HaLow Antenna for Rover (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, HaLow Antenna for Rover, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'high-rtk-antenna-mount',
    slug: 'high-rtk-antenna-mount',
    sku: 'YARBO-HIGH-RTK-ANTENNA-MOUNT',
    name: 'High RTK Antenna Mount (Y Series)',
    price: 26.0,
    priceDisplay: '$26.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/High_RTK_Antenna_Mount_New_1_pc.png?v=1777095774&width=533',
    websiteForgeImagePath:
      'uploaded/images/High_RTK_Antenna_Mount_New_1_pc.png',
    descriptionHtml:
      '<p>Official High RTK Antenna Mount (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official High RTK Antenna Mount (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo High RTK Antenna Mount | RTK Accessory',
    seoMetaDescription:
      'Shop High RTK Antenna Mount (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, High RTK Antenna Mount, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-lawn-mower',
    slug: 'yarbo-lawn-mower',
    sku: 'YARBO-LAWN-MOWER',
    name: 'Yarbo Lawn Mower',
    price: 4199.0,
    priceDisplay: '$4,199.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Complete System',
    publicCategories: ['Complete Systems', 'Robot Lawn Mowers'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Robot Lawn Mowers',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower.png?v=1777093280&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Lawn_Mower.png',
    descriptionHtml:
      '<p>A complete Yarbo robotic lawn mower system for scheduled mowing, wire-free virtual boundaries, and routine lawn maintenance.</p>\n<ul>\n<li>Up to 6 acres twice per week</li>\n<li>App-defined virtual boundaries</li>\n<li>Auto-recharge and resume operation</li>\n</ul>\n<p><strong>Includes:</strong> Yarbo Core, Lawn Mower Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation &amp; Tool Kit, Tow Hitch, Cutting Disc &amp; Bolts.</p>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A complete Yarbo robotic lawn mower system for scheduled mowing, wire-free virtual boundaries, and routine lawn maintenance. Up to 6 acres twice per week; App-defined virtual boundaries; Auto-recharge and resume operation Includes: Yarbo Core, Lawn Mower Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation & Tool Kit, Tow Hitch, Cutting Disc & Bolts. Product Brochure',
    weightLbs: 198.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: false,
    isCompleteSystem: true,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower | Wire-Free Robot Lawn Mower',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower, a wire-free robot lawn mower for scheduled yard care, virtual boundaries, auto-recharge, and large lawns.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-lawn-mower',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote:
      'Official Yarbo Wiki full mower + core weight: 90 kg / 198 lbs.',
  },
  {
    id: 'yarbo-lawn-mower-blower',
    slug: 'yarbo-lawn-mower-blower',
    sku: 'YARBO-LAWN-MOWER-BLOWER',
    name: 'Yarbo Lawn Mower + Blower',
    price: 4999.0,
    priceDisplay: '$4,999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Blower.png?v=1777093281&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Lawn_Mower_Blower.png',
    descriptionHtml:
      '<p>A Yarbo bundle for automated mowing and outdoor debris cleanup.</p>\n<ul>\n<li>Robot lawn mowing</li>\n<li>Leaf and debris blowing</li>\n<li>Useful bundle for lawn care and seasonal cleanup</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A Yarbo bundle for automated mowing and outdoor debris cleanup. Robot lawn mowing; Leaf and debris blowing; Useful bundle for lawn care and seasonal cleanup Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower + Leaf Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower + Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower + Blower, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-lawn-mower-blower',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'lawn-mower-module',
    slug: 'lawn-mower-module',
    sku: 'YARBO-LAWN-MOWER-MODULE',
    name: 'Lawn Mower Module (Y Series)',
    price: 999.0,
    priceDisplay: '$999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Lawn_Mower_Module.png?v=1777093279&width=533',
    websiteForgeImagePath: 'uploaded/images/Lawn_Mower_Module.png',
    descriptionHtml:
      '<p>A module-only Yarbo Lawn Mower attachment for customers who already own, or are purchasing, a compatible Yarbo Core.</p>\n<ul>\n<li>Module-only product</li>\n<li>Designed for scheduled robotic mowing</li>\n<li>Requires a compatible Yarbo Core</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A module-only Yarbo Lawn Mower attachment for customers who already own, or are purchasing, a compatible Yarbo Core. Module-only product; Designed for scheduled robotic mowing; Requires a compatible Yarbo Core Product Brochure',
    weightLbs: 66.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Lawn Mower Module | Robot Mower Module',
    seoMetaDescription:
      'Shop Lawn Mower Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Lawn Mower Module, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/lawn-mower-module',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote: 'Official Yarbo Wiki module-only weight: 30 kg / 66 lbs.',
  },
  {
    id: 'lawn-mower-module-cover',
    slug: 'lawn-mower-module-cover',
    sku: 'YARBO-LAWN-MOWER-MODULE-COVER',
    name: 'Lawn Mower Module Cover (Y Series)',
    price: 30.0,
    priceDisplay: '$30.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Lawn_Mower_Module_Cover.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Lawn_Mower_Module_Cover.png',
    descriptionHtml:
      '<p>Official Lawn Mower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Lawn Mower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Lawn Mower Module Cover',
    seoMetaDescription:
      'Shop Lawn Mower Module Cover (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Lawn Mower Module Cover, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower, Yarbo module, Yarbo Y Series module, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-lawn-mower-pro',
    slug: 'yarbo-lawn-mower-pro',
    sku: 'YARBO-LAWN-MOWER-PRO',
    name: 'Yarbo Lawn Mower Pro',
    price: 5599.0,
    priceDisplay: '$5,599.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Complete System',
    publicCategories: ['Complete Systems', 'Robot Lawn Mowers'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Robot Lawn Mowers',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro.png?v=1777093280&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Lawn_Mower_Pro.png',
    descriptionHtml:
      '<p>A premium Yarbo complete mowing system for homeowners who want stronger cutting power for thick, wet, or demanding lawns.</p>\n<ul>\n<li>Dual 300W motors</li>\n<li>Up to 2500W peak cutting power</li>\n<li>Complete system with Yarbo Core and Lawn Mower Pro Module</li>\n</ul>\n<p><strong>Includes:</strong> Yarbo Core, Lawn Mower Pro Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation &amp; Tool Kit, Tow Hitch, straight blades and cutting discs.</p>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A premium Yarbo complete mowing system for homeowners who want stronger cutting power for thick, wet, or demanding lawns. Dual 300W motors; Up to 2500W peak cutting power; Complete system with Yarbo Core and Lawn Mower Pro Module Includes: Yarbo Core, Lawn Mower Pro Module, Docking Station, Y Series Battery, Wired Charger, Data Center, Installation & Tool Kit, Tow Hitch, straight blades and cutting discs. Product Brochure',
    weightLbs: 216.4,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: false,
    isCompleteSystem: true,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower Pro | Robot Mower for Large Yards',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower Pro, a robotic lawn mower for large, thick, or demanding lawns. View price, features, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-lawn-mower-pro',
    weightSource: 'https://www.yarbo.com/products/yarbo-lawn-mower-pro',
    weightNote:
      'Official Yarbo product-page search result showed Lawn Mower Pro weight 216.4 lbs / 98.2 kg.',
  },
  {
    id: 'yarbo-lawn-mower-pro-blower',
    slug: 'yarbo-lawn-mower-pro-blower',
    sku: 'YARBO-LAWN-MOWER-PRO-BLOWER',
    name: 'Yarbo Lawn Mower Pro + Blower',
    price: 6499.0,
    priceDisplay: '$6,499.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro_Blower.png?v=1777093280&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Lawn_Mower_Pro_Blower.png',
    descriptionHtml:
      '<p>A mowing and cleanup bundle built around the Yarbo Lawn Mower Pro and Blower modules.</p>\n<ul>\n<li>Pro mowing system</li>\n<li>Leaf and debris cleanup</li>\n<li>Good fit for yards with heavier mowing needs</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A mowing and cleanup bundle built around the Yarbo Lawn Mower Pro and Blower modules. Pro mowing system; Leaf and debris cleanup; Good fit for yards with heavier mowing needs Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower Pro + Leaf Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower Pro + Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower Pro + Blower, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-lawn-mower-pro-blower',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'lawn-mower-pro-module',
    slug: 'lawn-mower-pro-module',
    sku: 'YARBO-LAWN-MOWER-PRO-MODULE',
    name: 'Lawn Mower Pro Module (Y Series)',
    price: 2099.0,
    priceDisplay: '$2,099.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Lawn_Mower_Pro_Module.png?v=1777093279&width=1445',
    websiteForgeImagePath: 'uploaded/images/Lawn_Mower_Pro_Module.png',
    descriptionHtml:
      '<p>A module-only Lawn Mower Pro upgrade for compatible Yarbo Core owners or buyers building a Yarbo system.</p>\n<ul>\n<li>Module-only product</li>\n<li>Designed for heavier mowing conditions</li>\n<li>Requires a compatible Yarbo Core</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A module-only Lawn Mower Pro upgrade for compatible Yarbo Core owners or buyers building a Yarbo system. Module-only product; Designed for heavier mowing conditions; Requires a compatible Yarbo Core Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Lawn Mower Pro Module | Robot Mower Module',
    seoMetaDescription:
      'Shop Lawn Mower Pro Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Lawn Mower Pro Module, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-lawn-mower-pro-module',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-lawn-mower-pro-snow-blower',
    slug: 'yarbo-lawn-mower-pro-snow-blower',
    sku: 'YARBO-LAWN-MOWER-PRO-SNOW-BLOWER',
    name: 'Yarbo Lawn Mower Pro + Snow Blower',
    price: 6699.0,
    priceDisplay: '$6,699.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro_Snow_Blower.png?v=1777093281&width=1445',
    websiteForgeImagePath:
      'uploaded/images/Yarbo_Lawn_Mower_Pro_Snow_Blower.png',
    descriptionHtml:
      '<p>A dual-season Yarbo bundle for buyers who want stronger mowing performance and robotic snow clearing in one system.</p>\n<ul>\n<li>Lawn Mower Pro setup</li>\n<li>Robotic snow blower module</li>\n<li>Complete system for mowing and winter clearing</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A dual-season Yarbo bundle for buyers who want stronger mowing performance and robotic snow clearing in one system. Lawn Mower Pro setup; Robotic snow blower module; Complete system for mowing and winter clearing Product Brochure',
    weightLbs: 293.4,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower Pro + Snow Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower Pro + Snow Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower Pro + Snow Blower, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl:
      'https://www.yarbo.com/products/yarbo-lawn-mower-pro-snow-blower',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote:
      'Calculated from official component weights: Lawn Mower Pro full unit 216.4 lbs + Snow Blower Module 77 lbs.',
  },
  {
    id: 'yarbo-lawn-mower-pro-snow-blower-blower',
    slug: 'yarbo-lawn-mower-pro-snow-blower-blower',
    sku: 'YARBO-LAWN-MOWER-PRO-SNOW-BLOWER-BLOWER',
    name: 'Yarbo Lawn Mower Pro + Snow Blower + Blower',
    price: 7499.0,
    priceDisplay: '$7,499.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Snow Removal', 'Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_4-in-1_Yard_Robot_with_Lawn_Mower_Pro_Module.png?v=1777093281&width=1445',
    websiteForgeImagePath:
      'uploaded/images/Yarbo_4-in-1_Yard_Robot_with_Lawn_Mower_Pro_Module.png',
    descriptionHtml:
      '<p>A premium all-season Yarbo bundle for mowing, snow clearing, and leaf cleanup with the Lawn Mower Pro setup.</p>\n<ul>\n<li>Best premium all-season Yarbo bundle</li>\n<li>Includes mower pro, snow blower, and blower functions</li>\n<li>Built around the modular Yarbo Y Series platform</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A premium all-season Yarbo bundle for mowing, snow clearing, and leaf cleanup with the Lawn Mower Pro setup. Best premium all-season Yarbo bundle; Includes mower pro, snow blower, and blower functions; Built around the modular Yarbo Y Series platform Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower Pro Snow Blower Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower Pro + Snow Blower + Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower Pro + Snow Blower + Blower, Yarbo Lawn Mower Pro, robot lawn mower for large yards, robotic lawn mower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl:
      'https://www.yarbo.com/products/yarbo-4-in-1-yard-robot-with-lawn-mower-pro-module',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-lawn-mower-snow-blower',
    slug: 'yarbo-lawn-mower-snow-blower',
    sku: 'YARBO-LAWN-MOWER-SNOW-BLOWER',
    name: 'Yarbo Lawn Mower + Snow Blower',
    price: 5199.0,
    priceDisplay: '$5,199.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower_Lawn_Mower.png?v=1777093281&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Snow_Blower_Lawn_Mower.png',
    descriptionHtml:
      '<p>A Yarbo bundle for homeowners who want robotic lawn mowing and robotic snow clearing in one modular platform.</p>\n<ul>\n<li>Mowing plus snow clearing</li>\n<li>Complete system with compatible modules</li>\n<li>Designed for repeat outdoor chores across seasons</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A Yarbo bundle for homeowners who want robotic lawn mowing and robotic snow clearing in one modular platform. Mowing plus snow clearing; Complete system with compatible modules; Designed for repeat outdoor chores across seasons Product Brochure',
    weightLbs: 275.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower + Snow Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower + Snow Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower + Snow Blower, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-snow-blower-lawn-mower',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote:
      'Calculated from official component weights: Lawn Mower full unit 198 lbs + Snow Blower Module 77 lbs.',
  },
  {
    id: 'yarbo-lawn-mower-snow-blower-blower',
    slug: 'yarbo-lawn-mower-snow-blower-blower',
    sku: 'YARBO-LAWN-MOWER-SNOW-BLOWER-BLOWER',
    name: 'Yarbo Lawn Mower + Snow Blower + Blower',
    price: 5999.0,
    priceDisplay: '$5,999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Lawn Care', 'Snow Removal', 'Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_4-in-1_Yard_Robot.png?v=1777093281&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_4-in-1_Yard_Robot.png',
    descriptionHtml:
      '<p>An all-season Yarbo bundle for mowing, snow clearing, and leaf cleanup with the standard Lawn Mower configuration.</p>\n<ul>\n<li>Complete multi-season Yarbo system</li>\n<li>Mow, clear snow, and blow leaves</li>\n<li>Strong value for year-round yard automation</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'An all-season Yarbo bundle for mowing, snow clearing, and leaf cleanup with the standard Lawn Mower configuration. Complete multi-season Yarbo system; Mow, clear snow, and blow leaves; Strong value for year-round yard automation Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Lawn Mower Snow Blower Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Lawn Mower + Snow Blower + Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Lawn Mower + Snow Blower + Blower, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-4-in-1-yard-robot',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'lawn-track',
    slug: 'lawn-track',
    sku: 'YARBO-LAWN-TRACK',
    name: 'Lawn Track (Y Series)',
    price: 139.0,
    priceDisplay: '$139.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Lawn_Track.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Lawn_Track.png',
    descriptionHtml:
      '<p>Official Lawn Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Lawn Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Lawn Track | Replacement Track',
    seoMetaDescription:
      'Shop Lawn Track (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Lawn Track, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'mini-yarbo-blower-3d-model',
    slug: 'mini-yarbo-blower-3d-model',
    sku: 'YARBO-MINI-BLOWER-3D-MODEL',
    name: 'Mini Yarbo Blower 3D Model (Y Series)',
    price: 399.0,
    priceDisplay: '$399.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Mini Models'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Mini Models',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Mini_Yarbo_Blower_3D_Model.png?v=1777095774&width=533',
    websiteForgeImagePath: 'uploaded/images/Mini_Yarbo_Blower_3D_Model.png',
    descriptionHtml:
      '<p>Official Mini Yarbo Blower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Mini Yarbo Blower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Mini Yarbo Blower 3D Model',
    seoMetaDescription:
      'Shop Mini Yarbo Blower 3D Model (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Mini Yarbo Blower 3D Model, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'mini-yarbo-core-3d-model',
    slug: 'mini-yarbo-core-3d-model',
    sku: 'YARBO-MINI-CORE-3D-MODEL',
    name: 'Mini Yarbo Core 3D Model (Y Series)',
    price: 399.0,
    priceDisplay: '$399.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Mini Models'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Mini Models',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Mini_Yarbo_Core_3D_Model.png?v=1777095774&width=533',
    websiteForgeImagePath: 'uploaded/images/Mini_Yarbo_Core_3D_Model.png',
    descriptionHtml:
      '<p>Official Mini Yarbo Core 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Mini Yarbo Core 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Mini Yarbo Core 3D Model',
    seoMetaDescription:
      'Shop Mini Yarbo Core 3D Model (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Mini Yarbo Core 3D Model',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'mini-yarbo-lawn-mower-3d-model',
    slug: 'mini-yarbo-lawn-mower-3d-model',
    sku: 'YARBO-MINI-LAWN-MOWER-3D-MODEL',
    name: 'Mini Yarbo Lawn Mower 3D Model (Y Series)',
    price: 399.0,
    priceDisplay: '$399.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Mini Models'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Mini Models',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Mini_Yarbo_Lawn_Mower_3D_Model.png?v=1777095775&width=533',
    websiteForgeImagePath: 'uploaded/images/Mini_Yarbo_Lawn_Mower_3D_Model.png',
    descriptionHtml:
      '<p>Official Mini Yarbo Lawn Mower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Mini Yarbo Lawn Mower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Mini Yarbo Lawn Mower 3D Model',
    seoMetaDescription:
      'Shop Mini Yarbo Lawn Mower 3D Model (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Mini Yarbo Lawn Mower 3D Model, Yarbo robot lawn mower, wire-free robot lawn mower, autonomous lawn mower',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'mini-yarbo-snow-blower-3d-model',
    slug: 'mini-yarbo-snow-blower-3d-model',
    sku: 'YARBO-MINI-SNOW-BLOWER-3D-MODEL',
    name: 'Mini Yarbo Snow Blower 3D Model (Y Series)',
    price: 399.0,
    priceDisplay: '$399.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Mini Models'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Mini Models',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Mini_Yarbo_Snow_Blower_3D_Model.png?v=1777095774&width=533',
    websiteForgeImagePath:
      'uploaded/images/Mini_Yarbo_Snow_Blower_3D_Model.png',
    descriptionHtml:
      '<p>Official Mini Yarbo Snow Blower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Mini Yarbo Snow Blower 3D Model (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Mini Yarbo Snow Blower 3D Model',
    seoMetaDescription:
      'Shop Mini Yarbo Snow Blower 3D Model (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Mini Yarbo Snow Blower 3D Model, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'poe-power-adapter',
    slug: 'poe-power-adapter',
    sku: 'YARBO-POE-POWER-ADAPTER',
    name: 'POE Power Adapter (Y Series)',
    price: 32.0,
    priceDisplay: '$32.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Power & Charging',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Power & Charging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/POE_Power_Adapter.png?v=1777095773&width=533',
    websiteForgeImagePath: 'uploaded/images/POE_Power_Adapter.png',
    descriptionHtml:
      '<p>Official POE Power Adapter (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official POE Power Adapter (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo POE Power Adapter | Data Center Accessory',
    seoMetaDescription:
      'Shop POE Power Adapter (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, POE Power Adapter',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'remote-controller',
    slug: 'remote-controller',
    sku: 'YARBO-REMOTE-CONTROLLER',
    name: 'Remote Controller',
    price: 59.0,
    priceDisplay: '$59.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Controllers'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Controllers',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Remote_Controller_-_2024_Version.png?v=1777095774&width=533',
    websiteForgeImagePath:
      'uploaded/images/Remote_Controller_-_2024_Version.png',
    descriptionHtml:
      '<p>Official Remote Controller for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Remote Controller for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Remote Controller | Yard Robot Accessory',
    seoMetaDescription:
      'Shop Remote Controller for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Remote Controller',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'rtk-antenna-for-data-center-and-rover',
    slug: 'rtk-antenna-for-data-center-and-rover',
    sku: 'YARBO-RTK-ANTENNA-FOR-DATA-CENTER-ROVER',
    name: 'RTK Antenna for Data Center & Rover (Y Series)',
    price: 30.0,
    priceDisplay: '$30.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/RTK_Antenna_for_Data_Center_Rover.png?v=1777095773&width=533',
    websiteForgeImagePath:
      'uploaded/images/RTK_Antenna_for_Data_Center_Rover.png',
    descriptionHtml:
      '<p>Official RTK Antenna for Data Center &amp; Rover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official RTK Antenna for Data Center & Rover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo RTK Antenna for Data Center & Rover',
    seoMetaDescription:
      'Shop RTK Antenna for Data Center & Rover (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, RTK Antenna for Data Center & Rover, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'rtk-antenna-pro-for-data-center-and-rover',
    slug: 'rtk-antenna-pro-for-data-center-and-rover',
    sku: 'YARBO-RTK-ANTENNA-PRO-FOR-DATA-CENTER-ROVER',
    name: 'RTK Antenna Pro for Data Center & Rover',
    price: 66.0,
    priceDisplay: '$66.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Antennas & Signal',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Antennas & Signal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/20260514-164907.jpg?v=1778748580&width=533',
    websiteForgeImagePath: 'uploaded/images/20260514-164907.jpg',
    descriptionHtml:
      '<p>Official RTK Antenna Pro for Data Center &amp; Rover for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official RTK Antenna Pro for Data Center & Rover for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo RTK Antenna Pro for Data Center & Rover',
    seoMetaDescription:
      'Shop RTK Antenna Pro for Data Center & Rover for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, RTK Antenna Pro for Data Center & Rover, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'scraper-bar',
    slug: 'scraper-bar',
    sku: 'YARBO-SCRAPER-BAR',
    name: 'Scraper Bar (Y Series)',
    price: 59.0,
    priceDisplay: '$59.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Scraper_Bar.png?v=1777095773&width=533',
    websiteForgeImagePath: 'uploaded/images/Scraper_Bar.png',
    descriptionHtml:
      '<p>Official Scraper Bar (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Scraper Bar (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Scraper Bar | Snow Blower Part',
    seoMetaDescription:
      'Shop Scraper Bar (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Scraper Bar, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'shear-pins-and-cotter-pins-set',
    slug: 'shear-pins-and-cotter-pins-set',
    sku: 'YARBO-SHEAR-PINS-COTTER-PINS-SET',
    name: 'Shear Pins & Cotter Pins Set (Set of 8) (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Shear_Pins_Cotter_Pins_Set_8_Sets.png?v=1777095772&width=533',
    websiteForgeImagePath:
      'uploaded/images/Shear_Pins_Cotter_Pins_Set_8_Sets.png',
    descriptionHtml:
      '<p>Official Shear Pins &amp; Cotter Pins Set (Set of 8) (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Shear Pins & Cotter Pins Set (Set of 8) (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Shear Pins & Cotter Pins | Snow Parts',
    seoMetaDescription:
      'Shop Shear Pins & Cotter Pins Set (Set of 8) (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Shear Pins & Cotter Pins Set (Set of 8), Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'smart-assist-module',
    slug: 'smart-assist-module',
    sku: 'YARBO-SMART-ASSIST-MODULE',
    name: 'Smart Assist Module (Y Series)',
    price: 299.0,
    priceDisplay: '$299.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories', 'Smart Assist'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
      '/Shop Yarbo/Smart Assist',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Smart_Assist_Module.png?v=1777093277&width=533',
    websiteForgeImagePath: 'uploaded/images/Smart_Assist_Module.png',
    descriptionHtml:
      '<p>The Yarbo Smart Assist Module is an official Y Series module accessory for supported Yarbo setups.</p>\n<ul>\n<li>Official Yarbo Y Series module</li>\n<li>Designed for compatible Yarbo systems</li>\n<li>Useful for expanding supported Yarbo functionality</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'The Yarbo Smart Assist Module is an official Y Series module accessory for supported Yarbo setups. Official Yarbo Y Series module; Designed for compatible Yarbo systems; Useful for expanding supported Yarbo functionality Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Smart Assist Module | Y Series Accessory',
    seoMetaDescription:
      'Shop Smart Assist Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Smart Assist Module, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'smart-assist-module-cover',
    slug: 'smart-assist-module-cover',
    sku: 'YARBO-SMART-ASSIST-MODULE-COVER',
    name: 'Smart Assist Module Cover (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Smart Assist'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Smart Assist',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Smart_Assist_Module_Cover.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Smart_Assist_Module_Cover.png',
    descriptionHtml:
      '<p>Official Smart Assist Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Smart Assist Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Smart Assist Module Cover',
    seoMetaDescription:
      'Shop Smart Assist Module Cover (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Smart Assist Module Cover, Yarbo module, Yarbo Y Series module, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-snow-blower',
    slug: 'yarbo-snow-blower',
    sku: 'YARBO-SNOW-BLOWER',
    name: 'Yarbo Snow Blower',
    price: 4999.0,
    priceDisplay: '$4,999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Complete System',
    publicCategories: ['Complete Systems', 'Robotic Snow Blowers'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Robotic Snow Blowers',
      '/Shop by Task/Snow Removal',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower.png?v=1777093280&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Snow_Blower.png',
    descriptionHtml:
      '<p>A complete Yarbo robotic snow blower system for autonomous driveway and path clearing.</p>\n<ul>\n<li>2-stage snow blower design</li>\n<li>24-inch clearing width</li>\n<li>Clears up to 12 inches of snow</li>\n</ul>\n<p><strong>Includes:</strong> Yarbo Core, Snow Blower Module, Wired Charger, Data Center, Installation &amp; Tool Kit, Y Series Battery, Docking Station, Snow Track, Cleaning Shovel and Tow Hitch.</p>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A complete Yarbo robotic snow blower system for autonomous driveway and path clearing. 2-stage snow blower design; 24-inch clearing width; Clears up to 12 inches of snow Includes: Yarbo Core, Snow Blower Module, Wired Charger, Data Center, Installation & Tool Kit, Y Series Battery, Docking Station, Snow Track, Cleaning Shovel and Tow Hitch. Product Brochure',
    weightLbs: 228.5,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: false,
    isCompleteSystem: true,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Snow Blower | Robotic Snow Blower',
    seoMetaDescription:
      'Shop Yarbo Snow Blower, a robotic snow blower for driveway and path clearing with a 2-stage design and 24-inch clearing width.',
    seoMetaKeywords:
      'Yarbo, Yarbo Snow Blower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-snow-blower',
    weightSource: 'https://uk.yarbo.com/products/snow-blower-robot',
    weightNote:
      'Official Yarbo UK snow blower spec: total weight 228.5 lbs / 103.5 kg.',
  },
  {
    id: 'yarbo-snow-blower-blower',
    slug: 'yarbo-snow-blower-blower',
    sku: 'YARBO-SNOW-BLOWER-BLOWER',
    name: 'Yarbo Snow Blower + Blower',
    price: 5999.0,
    priceDisplay: '$5,999.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Bundle',
    publicCategories: ['Complete Systems', 'Bundles', 'All-Season Bundles'],
    taskCategories: ['Snow Removal', 'Leaf Cleanup'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Complete Systems',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop by Task/Leaf Cleanup',
      '/Shop Yarbo/Bundles',
      '/Shop Yarbo/All-Season Bundles',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower_Blower.png?v=1777093296&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Snow_Blower_Blower.png',
    descriptionHtml:
      '<p>A Yarbo snow and debris cleanup bundle for buyers focused on winter clearing and leaf/debris management.</p>\n<ul>\n<li>Snow removal plus blower functions</li>\n<li>Modular Y Series platform</li>\n<li>Good fit for driveway and cleanup tasks</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A Yarbo snow and debris cleanup bundle for buyers focused on winter clearing and leaf/debris management. Snow removal plus blower functions; Modular Y Series platform; Good fit for driveway and cleanup tasks Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: false,
    isModule: false,
    isBundle: true,
    isCompleteSystem: false,
    eligibleForYarboCare: true,
    seoTitle: 'Yarbo Snow Blower + Leaf Blower Bundle',
    seoMetaDescription:
      'Shop Yarbo Snow Blower + Blower, a Yarbo bundle for multi-season robotic yard care. Compare features, view pricing, and add to cart online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Snow Blower + Blower, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/yarbo-snow-blower-blower',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'snow-blower-module',
    slug: 'snow-blower-module',
    sku: 'YARBO-SNOW-BLOWER-MODULE',
    name: 'Snow Blower Module (Y Series)',
    price: 1299.0,
    priceDisplay: '$1,299.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Snow_Blower_Module.png?v=1777093280&width=533',
    websiteForgeImagePath: 'uploaded/images/Snow_Blower_Module.png',
    descriptionHtml:
      '<p>A module-only Yarbo Snow Blower attachment for compatible Yarbo Core owners or system builders.</p>\n<ul>\n<li>Module-only product</li>\n<li>Designed for robotic snow clearing</li>\n<li>Requires a compatible Yarbo Core</li>\n</ul>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A module-only Yarbo Snow Blower attachment for compatible Yarbo Core owners or system builders. Module-only product; Designed for robotic snow clearing; Requires a compatible Yarbo Core Product Brochure',
    weightLbs: 77.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Snow Blower Module | Robotic Snow Module',
    seoMetaDescription:
      'Shop Snow Blower Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Snow Blower Module, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/snow-blower-module',
    weightSource:
      'https://wiki.yarbo.com/getting-started/specifications-and-dimensions',
    weightNote: 'Official Yarbo Wiki module weight: 35 kg / 77 lbs.',
  },
  {
    id: 'snow-blower-module-cover',
    slug: 'snow-blower-module-cover',
    sku: 'YARBO-SNOW-BLOWER-MODULE-COVER',
    name: 'Snow Blower Module Cover (Y Series)',
    price: 35.0,
    priceDisplay: '$35.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Snow_Blower_Module_Cover.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Snow_Blower_Module_Cover.png',
    descriptionHtml:
      '<p>Official Snow Blower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Snow Blower Module Cover (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Snow Blower Module Cover',
    seoMetaDescription:
      'Shop Snow Blower Module Cover (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Snow Blower Module Cover, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo leaf blower, robotic leaf blower, yard cleanup robot, Yarbo module, Yarbo Y Series module, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'snow-plow-blade',
    slug: 'snow-plow-blade',
    sku: 'YARBO-SNOW-PLOW-BLADE',
    name: 'Snow Plow Blade (Y Series)',
    price: 159.0,
    priceDisplay: '$159.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Snow_Plow_Blade.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Snow_Plow_Blade.png',
    descriptionHtml:
      '<p>Official Snow Plow Blade (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Snow Plow Blade (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Snow Plow Blade | Snow Blower Accessory',
    seoMetaDescription:
      'Shop Snow Plow Blade (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Snow Plow Blade, Yarbo snow blower, robotic snow blower, robotic snow removal, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'snow-shovel',
    slug: 'snow-shovel',
    sku: 'YARBO-SNOW-SHOVEL',
    name: 'Snow Shovel (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Snow_Shovel.png?v=1777095773&width=533',
    websiteForgeImagePath: 'uploaded/images/Snow_Shovel.png',
    descriptionHtml:
      '<p>Official Snow Shovel (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Snow Shovel (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Snow Shovel | Snow Blower Accessory',
    seoMetaDescription:
      'Shop Snow Shovel (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Snow Shovel, Yarbo snow blower, robotic snow blower, robotic snow removal',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=3',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'snow-track',
    slug: 'snow-track',
    sku: 'YARBO-SNOW-TRACK',
    name: 'Snow Track (Y Series)',
    price: 189.0,
    priceDisplay: '$189.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Snow_Track.png?v=1777095775&width=533',
    websiteForgeImagePath: 'uploaded/images/Snow_Track.png',
    descriptionHtml:
      '<p>Official Snow Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Snow Track (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Snow Track | Replacement Track',
    seoMetaDescription:
      'Shop Snow Track (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Snow Track, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'straight-blades-and-bolts',
    slug: 'straight-blades-and-bolts',
    sku: 'YARBO-STRAIGHT-BLADES-BOLTS',
    name: 'Straight Blades & Bolts (Y Series)',
    price: 90.0,
    priceDisplay: '$90.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Lawn Care'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop by Task/Lawn Care',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Straight_Blades_Bolts_2_Pcs_for_Lawn_Mower_Pro_Module.png?v=1777095774&width=533',
    websiteForgeImagePath:
      'uploaded/images/Straight_Blades_Bolts_2_Pcs_for_Lawn_Mower_Pro_Module.png',
    descriptionHtml:
      '<p>Official Straight Blades &amp; Bolts (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Straight Blades & Bolts (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Straight Blades & Bolts | Mower Blades',
    seoMetaDescription:
      'Shop Straight Blades & Bolts (Y Series) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Straight Blades & Bolts, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-t-shirt',
    slug: 'yarbo-t-shirt',
    sku: 'YARBO-T-SHIRT',
    name: 'Yarbo T-shirt',
    price: 39.0,
    priceDisplay: '$39.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Apparel'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Apparel',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Cap-1.png?v=1777095772&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Cap-1.png',
    descriptionHtml:
      '<p>Official Yarbo T-shirt for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Yarbo T-shirt for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo T-Shirt | Yarbo Apparel',
    seoMetaDescription:
      'Shop Yarbo T-shirt, Yarbo apparel and branded gear available online.',
    seoMetaKeywords: 'Yarbo, Yarbo T-shirt',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'tow-hitch',
    slug: 'tow-hitch',
    sku: 'YARBO-TOW-HITCH',
    name: 'Tow Hitch (Y Series)',
    price: 69.0,
    priceDisplay: '$69.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Tow & Transport'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop by Task/Tow & Transport',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/TowHitch_1fb896f3-38bd-4ef4-b5a3-70568b73dff2.png?v=1778486344&width=533',
    websiteForgeImagePath:
      'uploaded/images/TowHitch_1fb896f3-38bd-4ef4-b5a3-70568b73dff2.png',
    descriptionHtml:
      '<p>Official Tow Hitch (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Tow Hitch (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Tow Hitch | Yard Robot Towing Accessory',
    seoMetaDescription:
      'Shop Tow Hitch (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords:
      'Yarbo, Tow Hitch, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'yarbo-track-grease',
    slug: 'yarbo-track-grease',
    sku: 'YARBO-TRACK-GREASE',
    name: 'Yarbo Track Grease (200 ml)',
    price: 49.0,
    priceDisplay: '$49.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories', 'Maintenance'],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Maintenance',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Track_Grease_200_ml.png?v=1777095774&width=533',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Track_Grease_200_ml.png',
    descriptionHtml:
      '<p>Official Yarbo Track Grease (200 ml) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Yarbo Track Grease (200 ml) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Track Grease | Track Maintenance',
    seoMetaDescription:
      'Shop Yarbo Track Grease (200 ml) for Yarbo Y Series maintenance and replacement parts. View price and buy online.',
    seoMetaKeywords:
      'Yarbo, Yarbo Track Grease (200 ml), Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=5',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'trimmer-line-spool',
    slug: 'trimmer-line-spool',
    sku: 'YARBO-TRIMMER-LINE-SPOOL',
    name: 'Trimmer Line Spool (Y Series)',
    price: 29.0,
    priceDisplay: '$29.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Trimming & Edging'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop by Task/Trimming & Edging',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Back_Brace_Mount-3.png?v=1777095776&width=533',
    websiteForgeImagePath: 'uploaded/images/Back_Brace_Mount-3.png',
    descriptionHtml:
      '<p>Official Trimmer Line Spool (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Trimmer Line Spool (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Trimmer Line Spool | Trimmer Accessory',
    seoMetaDescription:
      'Shop Trimmer Line Spool (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Trimmer Line Spool',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'trimmer-module',
    slug: 'trimmer-module',
    sku: 'YARBO-TRIMMER-MODULE',
    name: 'Trimmer Module (Y Series)',
    price: 799.0,
    priceDisplay: '$799.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Module',
    publicCategories: ['Modules', 'Modules & Accessories'],
    taskCategories: ['Trimming & Edging'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Modules',
      '/Shop by Task/Trimming & Edging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Trimmer_Package.png?v=1777093279&width=1445',
    websiteForgeImagePath: 'uploaded/images/Yarbo_Trimmer_Package.png',
    descriptionHtml:
      '<p>A Yarbo trimmer module package for edge and detail trimming with compatible Yarbo systems.</p>\n<ul>\n<li>Includes Yarbo Trimmer and Back Brace Mount</li>\n<li>Automatic line feed</li>\n<li>Adjustable trimming height</li>\n</ul>\n<p><strong>Includes:</strong> Trimmer Package and spare Trimmer Line Spool.</p>\n<p><a href="https://wiki.yarbo.com/getting-started/brochure" target="_blank">Product Brochure</a></p>',
    descriptionText:
      'A Yarbo trimmer module package for edge and detail trimming with compatible Yarbo systems. Includes Yarbo Trimmer and Back Brace Mount; Automatic line feed; Adjustable trimming height Includes: Trimmer Package and spare Trimmer Line Spool. Product Brochure',
    weightLbs: 0.0,
    options: '',
    requiresCore: true,
    isAccessory: false,
    isModule: true,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Trimmer Module | Robotic Yard Trimming',
    seoMetaDescription:
      'Shop Trimmer Module (Y Series), a Yarbo Y Series module for compatible Yarbo Core systems. View details, price, and buy online.',
    seoMetaKeywords:
      'Yarbo, Trimmer Module, Yarbo module, Yarbo Y Series module',
    brochureUrl: 'https://wiki.yarbo.com/getting-started/brochure',
    brochureLinkText: 'Product Brochure',
    sourceUrl: 'https://www.yarbo.com/products/trimmer-back-brace-mount',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'weighted-side-plate',
    slug: 'weighted-side-plate',
    sku: 'YARBO-WEIGHTED-SIDE-PLATE',
    name: 'Weighted Side Plate (Y Series)',
    price: 99.0,
    priceDisplay: '$99.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: ['Accessories', 'Modules & Accessories'],
    taskCategories: ['Snow Removal'],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop by Task/Snow Removal',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Weighted_Side_Plate_2pcs.png?v=1777095773&width=533',
    websiteForgeImagePath: 'uploaded/images/Weighted_Side_Plate_2pcs.png',
    descriptionHtml:
      '<p>Official Weighted Side Plate (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Weighted Side Plate (Y Series) for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Weighted Side Plate | Snow Accessory',
    seoMetaDescription:
      'Shop Weighted Side Plate (Y Series) for Yarbo Y Series robotic yard care systems. View product details, pricing, images, and buy online.',
    seoMetaKeywords: 'Yarbo, Weighted Side Plate',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=2',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
  {
    id: 'wired-charger',
    slug: 'wired-charger',
    sku: 'YARBO-WIRED-CHARGER',
    name: 'Wired Charger',
    price: 99.0,
    priceDisplay: '$99.00',
    status: 'in-stock',
    stockLabel: 'In Stock',
    primaryGroup: 'Accessory',
    publicCategories: [
      'Accessories',
      'Modules & Accessories',
      'Power & Charging',
    ],
    taskCategories: [],
    categories: [
      '/Shop Yarbo',
      '/Shop Yarbo/All Products',
      '/Shop by Brand/Yarbo',
      '/Shop Yarbo/Y Series',
      '/Shop Yarbo/Modules & Accessories',
      '/Shop Yarbo/Accessories',
      '/Shop Yarbo/Power & Charging',
    ],
    imageUrl:
      'https://www.yarbo.com/cdn/shop/files/Wired_Charger.png?v=1777095775&width=533',
    websiteForgeImagePath: 'uploaded/images/Wired_Charger.png',
    descriptionHtml:
      '<p>Official Wired Charger for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup.</p>\n<ul>\n<li>Official Yarbo accessory or replacement part</li>\n<li>Designed for compatible Yarbo systems</li>\n</ul>',
    descriptionText:
      'Official Wired Charger for Yarbo systems. Use this accessory or replacement part to maintain, protect, or expand a compatible Yarbo setup. Official Yarbo accessory or replacement part; Designed for compatible Yarbo systems',
    weightLbs: 0.0,
    options: '',
    requiresCore: false,
    isAccessory: true,
    isModule: false,
    isBundle: false,
    isCompleteSystem: false,
    eligibleForYarboCare: false,
    seoTitle: 'Yarbo Wired Charger | Y Series Charger',
    seoMetaDescription:
      'Shop Wired Charger for Yarbo Y Series systems. Buy replacement power and charging parts online.',
    seoMetaKeywords:
      'Yarbo, Wired Charger, Yarbo accessories, Yarbo replacement parts',
    brochureUrl: '',
    brochureLinkText: '',
    sourceUrl: 'https://www.yarbo.com/collections/all-products?page=4',
    weightSource: '',
    weightNote:
      'No official product weight found in current Yarbo source pages during this pass.',
  },
]
